<script>
	// Stores
	import { 
		linkMapa,
		linkWaze,
		linkUber,
		linkAV, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		linkFacebook,
		linkInstagram,
		linkTwitter,
		linkYoutube,
		linkWhatsappVendas,
		linkWhatsappLocacao,
		linkPoliticaPrivacidade,
		linkPoliticaCookies
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	const contatos = [
	{
		title: 'Atendimento Geral',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/555432781001',
		target: '_blank',
		phone: '(54) 3278-1001',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Vendas',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554991774368',
		target: '_blank',
		phone: '(54) 99177-4368',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Plantão (SOMENTE URGÊNCIAS) após 18h, sábados, domingos e feriados',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554999747324',
		target: '_blank',
		phone: '(54) 99974-7324',
		email: 'siteatendimento@serraelar.com.br'
	},
	];
	const social = [
		{
			title: 'Facebook',
			link: $linkFacebook,
			icon: '<i class="fab fa-facebook fa-2x"></i>'
		},
		{
			title: 'Instagram',
			link: $linkInstagram,
			icon: '<i class="fab fa-instagram fa-2x"></i>'
		},
	];
</script>

<footer>
	<section class="footer-banner pt-40 pb-40">
		<div class="container">
			<div class="flex sm-flex-column flex-center">
				<div class="flex-1">
					<img src="/assets/images/logotipoFooter.png" alt="Logotipo da Serra e Lar" />
				</div>
				<div class="flex flex-column flex-end sm-flex-center gap-10 sm-pt-40">
					{#each contatos as contato}
					<div class="flex flex-center gap-5 sm-flex-column">
						<span class="title">{@html contato.title}<span class="hidden-sm hidden-xs"> </span></span>
						<span class="number"><a target="_blank" href="{contato.href}">{@html contato.icon} {contato.phone}</a></span>
					</div>
					{/each}
				</div>
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="content flex sm-flex-column sm-flex-center">
				<div class="seo">
					<p>{@html $tagsSEO}</p>
					<div class="flex flex-start sm-flex-center gap-10">
						{#each social as item}
							<a href="{item.link}" use:link replace title="Ir para {item.title}" target="_blank">{@html item.icon != null ? item.icon : ""}</a>
						{/each}
					</div>
				</div>
				<div class="flex-1 localizacao">
					<h4 class="color-accent"><i class="fas fa-clock"></i> Horário</h4>
					<p>{@html $textAtendimento}</p>
				</div>
				<div class="sede">
					<h4 class="color-accent"><i class="fas fa-map"></i> Localização</h4>
					<p>{@html $textEndereco}</p>
					<div class="travel flex gap-10 pb-20">
						<a href={$linkMapa} target="_blank"><i class="fal fa-map-marked-alt"></i> Mapa</a>
						<a href={$linkWaze} target="_blank"><i class="fab fa-waze"></i> Waze</a>
						<a href={$linkUber} target="_blank"><i class="fab fa-uber"></i> Uber</a>
					</div>
				</div>
			</div>
			<div class="text-center">
				<a class="text-smaller" href={$linkPoliticaPrivacidade} target="_blank">- Política de Privacidade -</a>
			</div>
			<div class="copyright">
				<copy>@ 2023 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os direitos reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></copy>
			</div>
		</div>
	</section>
</footer>